type IdmProfilePictureSource = {
  profile_picture_image_id?: string | null;
  profile_picture_url?: string | null;
  [key: string]: unknown;
};

/**
 * Map reserved IDM Profile Picture keys into the Dashboard User model.
 * Ordinary profile writes must not author these keys.
 */
export function mapIdmProfilePictureFields(profile: IdmProfilePictureSource = {}) {
  return {
    profilePictureImageId:
      profile.profile_picture_image_id === undefined ? null : profile.profile_picture_image_id,
    profilePictureUrl:
      profile.profile_picture_url === undefined ? null : profile.profile_picture_url,
  };
}
